module.exports = __webpack_public_path__ + "media/images/Signature_Date_Icon-9100cd93.svg";